import React, { useState } from "react";
import { Formik } from "formik";

const initialValues = {
  status: "",
  searchName: "",
  searchCountryCode: "",
};
export function CountryFilter({ filterValues, myRef }) {
  const applyFilter = (values) => {
    filterValues(values);
  };

  const [countryFilter, setCountryFilter] = useState(initialValues);

  return (
    <>
      <Formik
        initialValues={countryFilter}
        onSubmit={(values) => {
          applyFilter(values);
          console.log(values);
        }}
        onReset={(values) => {
          console.log("Hello shankar", values);
          applyFilter(values);
        }}
      >
        {({
          values,
          handleSubmit,
          handleBlur,
          handleChange,
          setFieldValue,
          handleReset,
        }) => (
          <form onSubmit={handleSubmit} className="form form-label-right">
            <div className="form-group row">
              <div className="col-lg-2">
                <select
                  className="form-control"
                  name="status"
                  placeholder="Filter by status Type"
                  onChange={(e) => {
                    setFieldValue("status", e.target.value);
                    handleSubmit();
                  }}
                  onBlur={handleBlur}
                  value={values.status}
                >
                  <option value="">All</option>
                  <option value="1">Active</option>
                  <option value="0">Deactive</option>
                </select>
                <small className="form-text text-muted">
                  Filter by <b>Status</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchName"
                  placeholder="Country Name"
                  onBlur={handleBlur}
                  value={values.searchName}
                  onChange={(e) => {
                    setFieldValue("searchName", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Country Name</b>
                </small>
              </div>
              <div className="col-lg-2">
                <input
                  type="text"
                  className="form-control"
                  name="searchCountryCode"
                  placeholder="Country Code"
                  onBlur={handleBlur}
                  value={values.searchCountryCode}
                  onChange={(e) => {
                    setFieldValue("searchCountryCode", e.target.value);
                    handleSubmit();
                  }}
                />
                <small className="form-text text-muted">
                  Search by <b>Country Code</b>
                </small>
              </div>
              <div className="col-lg-2">
                <button
                  className="btn btn-white-primary"
                  onClick={handleReset}
                  ref={myRef}
                  style={{ display: "none" }}
                ></button>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </>
  );
}
